import { defineMessages } from 'react-intl';

export const addReviewPreviewMessages = defineMessages({
  hint: {
    defaultMessage: 'Hier kannst du deine Bewertung nochmal überprüfen',
    id: 'customerReviews.addReview.addReviewPreview.hint',
  },
});
